import React, { useEffect } from 'react';

import { CustomerTypeEnum, CustomerTypes } from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';
import Text from '@amzn/meridian/text';

import { partition } from 'lodash';
import { Toggle } from 'src/components/Toggle';
import { ContractTermSection } from 'src/components/shared/ContractTermSection';
import { DEFAULT_TOASTER_TIMEOUT } from 'src/constants';
import { CUSTOMER_TYPE_RATES_MESSAGE } from 'src/constants/rateCards';
import { AppContext } from 'src/contexts/appContext';
import { IToast } from 'src/types/IToaster';
import { getCamelStrFromAllCaps } from 'src/util/RateCards';

interface IViewCustomerType {
    customerTypes?: CustomerTypes;
}

export const ViewCustomerType = ({ customerTypes }: IViewCustomerType) => {
    const { setToasts } = React.useContext(AppContext);
    const allCustomerTypes = Object.keys(CustomerTypeEnum);

    const [validCustomerTypes, invalidCustomerTypes] = partition(customerTypes, (customerType) =>
        allCustomerTypes.includes(customerType)
    );

    useEffect(() => {
        invalidCustomerTypes.forEach((customerType) => {
            const toast: IToast = {
                id: `unknown-customer-type-${customerType}`,
                timeout: DEFAULT_TOASTER_TIMEOUT,
                message: `Contract contains unknown customer type: ${customerType}`,
                type: 'error'
            };
            setToasts((toasts) => [...toasts, toast]);
        });
    }, [customerTypes]);

    const selectedCustomerTypes = allCustomerTypes.map((customerType) => ({
        name: customerType,
        selected: validCustomerTypes.includes(customerType)
    }));

    const enableDifferentRates = validCustomerTypes.length > 0;

    return (
        <ContractTermSection title={'Customer type'}>
            <Toggle isEditMode={false} value={enableDifferentRates} label={CUSTOMER_TYPE_RATES_MESSAGE} />
            <Text type="h300">Customer types selected</Text>
            {selectedCustomerTypes.map((customerType) => {
                return (
                    <Toggle
                        isEditMode={false}
                        key={customerType.name}
                        value={customerType.selected}
                        label={getCamelStrFromAllCaps(customerType.name)}
                    />
                );
            })}
        </ContractTermSection>
    );
};
